import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { literalConstant } from '../../constant/literal.constant';

@Injectable({
  providedIn: 'root'
})
export class CustomizedHttpService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    @Inject(literalConstant.API_URL) private baseUrl: string
  ) {}

  private endPointFormater(endPoint: string, params: any[]): string {
    let value: string = this.baseUrl + endPoint;
    if (params && params.length > 0) {
      value = value + '/' + params.join('/');
    }
    return value;
  }

  public getByQuery<T>(url: string, httpParams: HttpParams): Observable<T> {
    return this.http.get<T>(this.baseUrl + url, { params: httpParams, headers: this.headers }).pipe(map((resp) => resp as T));
  }

  public get<T>(url: string, ...params: any[]): Observable<T> {
    return this.http.get<T>(this.endPointFormater(url, params), { headers: this.headers }).pipe(map((resp) => resp as T));
  }

  public getAll<T>(url: string, ...params: any[]): Observable<T[]> {
    return this.http.get(this.endPointFormater(url, params), { headers: this.headers }).pipe(map((resp) => resp as T[]));
  }

  public put<T, R>(url: string, obj?: T, ...params: any[]): Observable<R> {
    return this.http.put(this.endPointFormater(url, params), JSON.stringify(obj), { headers: this.headers }).pipe(map((resp) => resp as R));
  }

  public post<Req, Resp>(url: string, obj: Req, ...params: any[]): Observable<Resp> {
    return this.http.post(this.endPointFormater(url, params), JSON.stringify(obj), { headers: this.headers }).pipe(map((resp) => resp as Resp));
  }

  public delete<R>(url: string, ...params: any[]): Observable<R> {
    return this.http.delete(this.endPointFormater(url, params), { headers: this.headers }).pipe(map((resp) => resp as R));
  }
}
